import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { mergeWith, path } from 'ramda';
export function findParentElementFor(element, testFn) {
  if (!element) return null;
  if (testFn(element)) return element;
  if (!element.parentNode) return null;
  return findParentElementFor(element.parentNode, testFn);
}
export var getSubstate = function getSubstate(state, action) {
  return path(['external'].concat(_toConsumableArray(action.path)), state);
};
export var getSubstateFromGetState = function getSubstateFromGetState(getState, action) {
  return path(['external'].concat(_toConsumableArray(action.path)), getState());
};
export var deepMerge = function deepMerge(o1, o2) {
  if (o1 === null || o2 === null) {
    return o2;
  }
  if (Array.isArray(o1) || Array.isArray(o2)) {
    return o2;
  }
  if (_typeof(o1) === 'object' && _typeof(o2) === 'object') {
    var name1 = Object.prototype.toString.call(o1);
    var name2 = Object.prototype.toString.call(o2);
    if (name1 === name2 && name2 === '[object Object]') {
      return mergeWith(deepMerge, o1, o2);
    }
  }
  return o2;
};